import {marketsStore} from "../../stores/MarketsStore";
import {chartStore} from "../../stores/ChartStore";
import {ChartBar, MarketHistoryTimeframe} from "../../services/api/api.interfaces";
import {
    DatafeedConfiguration, ErrorCallback, HistoryCallback,
    IBasicDataFeed,
    LibrarySymbolInfo,
    OnReadyCallback, PeriodParams,
    ResolutionString, ResolveCallback, SearchSymbolsCallback, SubscribeBarsCallback, SymbolResolveExtension
} from "../../charting_library";

const resolutionToTimeframe: {[key: string]: MarketHistoryTimeframe} = {
    '1': MarketHistoryTimeframe['1M'],
    '5': MarketHistoryTimeframe['5M'],
    '15': MarketHistoryTimeframe['15M'],
    '30': MarketHistoryTimeframe['30M'],
    '60': MarketHistoryTimeframe['1H'],
    '240': MarketHistoryTimeframe['4H'],
    '1D': MarketHistoryTimeframe['1D'],
}
const configurationData: DatafeedConfiguration = {
    //supported from API: 1M, 5M, 15M, 30M, 1H, 4H, 1D
    supported_resolutions: [
        '1' as ResolutionString,
        '5' as ResolutionString,
        '15' as ResolutionString,
        '30' as ResolutionString,
        '60' as ResolutionString,
        '240' as ResolutionString,
        '1D' as ResolutionString
    ],
};

export const datafeed: IBasicDataFeed = {
    onReady: (callback: OnReadyCallback) => {
        // console.log('[onReady]: Method call');
        setTimeout(() => callback(configurationData));
    },
    searchSymbols: (userInput: string, exchange: string, symbolType: string, onResult: SearchSymbolsCallback)  => {
        // console.log('[searchSymbols]: Method call');
        // not used
    },
    resolveSymbol: (symbolName: string, onSymbolResolvedCallback: ResolveCallback, onResolveErrorCallback: ErrorCallback, extension: SymbolResolveExtension) => {
        // console.log('[resolveSymbol]: Method call', symbolName);

        const item = marketsStore.findMarketByName(symbolName)
        if (!item) {
            console.log('[resolveSymbol]: Cannot resolve symbol', symbolName);
            setTimeout(() => onResolveErrorCallback('Cannot resolve symbol'));
            return;
        }
        const info: LibrarySymbolInfo = {
            ticker: item.name,
            name: item.name,
            full_name: item.name,
            description: '',
            type: 'crypto',
            session: '24x7',
            timezone: 'Etc/UTC',
            exchange: '',
            listed_exchange: '',
            minmov: 1,
            pricescale: 10000,
            has_intraday: true,
            visible_plots_set: 'ohlc',
            has_weekly_and_monthly: false,
            supported_resolutions: configurationData.supported_resolutions,
            volume_precision: 2,
            data_status: 'streaming',
            format: 'price'
        };
        // console.log('[resolveSymbol]: Symbol resolved', symbolName);
        setTimeout(() => onSymbolResolvedCallback(info));
    },
    getBars: async (symbolInfo: LibrarySymbolInfo, resolution: ResolutionString, periodParams: PeriodParams, onHistoryCallback: HistoryCallback, onErrorCallback: ErrorCallback) => {
        // console.log('[getBars]: Method call', symbolInfo, resolution);

        try {
            const { from, to, firstDataRequest } = periodParams;

            const item = marketsStore.findMarketByName(symbolInfo.ticker || '')
            if (!item) {
                console.log('[resolveSymbol]: Cannot resolve symbol', symbolInfo.ticker);
                onErrorCallback('Cannot resolve bars');
                return;
            }

            const timeframe = resolutionToTimeframe[resolution]

            if (!timeframe) {
                onHistoryCallback([], { noData: true });
                return;
            }

            let bars: any[] = []

            if (firstDataRequest) {
                bars = await chartStore.fetchBars(item.baseAsset, item.quoteAsset, timeframe);
            } else {
                bars = chartStore.currentMarketChartBars
            }
            const fromMs = from * 1000
            const toMs = to * 1000
            bars = bars.filter((bar: ChartBar) => bar.time >= fromMs && bar.time < toMs)
            // console.log(`[getBars]: returned ${bars.length} bar(s) from: ${new Date(fromMs)} to: ${new Date(toMs)}`);

            onHistoryCallback(bars, { noData: false })
        } catch (error) {
            console.log('[getBars]: Get error', error);
            onErrorCallback('[getBars]: Get error');
        }
    },
    subscribeBars: (symbolInfo: LibrarySymbolInfo, resolution: ResolutionString, subscribeBarsCallback: SubscribeBarsCallback, subscriberUID: string, onResetCacheNeededCallback: () => void) => {
        // console.log('[subscribeBars]: Method call with symbolInfo:', symbolInfo);
        const item = marketsStore.findMarketByName(symbolInfo.ticker || '')

        if (!item) {
            console.log('[subscribeBars]: Cannot resolve symbol', symbolInfo.ticker);
            return;
        }
        chartStore.registerSubscription({subscriberUID, symbolItem: item, resolution, subscribeBarsCallback})

        // console.log('[subscribeBars]: Method call with subscriberUID:', subscriberUID);
    },
    unsubscribeBars: (subscriberUID: any) => {
        chartStore.unregisterSubscription(subscriberUID)

        // console.log('[unsubscribeBars]: Method call with subscriberUID:', subscriberUID);
    },
}